import { NOW_VALUE } from '../../constants';
import { dateToDateString } from '../../field-rule/inputs/utils';
export function resolveDefaultDateValue(field) {
    const defaultValue = field.view?.defaultValue;
    if (defaultValue === NOW_VALUE) {
        return dateToDateString(new Date());
    }
    return defaultValue;
}

//# sourceMappingURL=date-picker-default-value.js.map